<template>
	<div class="memorandum_create_block smal" :class="current_class">
		<!-- create menu_draw -->
		<div class="list_mem_create">

			<div id="panel_dashboard_create" class="panel "  v-if="show_create">

				<div class="panel-hdr bg-primary-500 bg-success-gradient">
					<h2>
                        <span class="icon-stack fs-xxl mr-2">
                            <i class="base base-7 icon-stack-3x opacity-100 color-primary-500"></i>
                            <i class="base base-7 icon-stack-2x opacity-100 color-primary-400"></i>
                            <i class="fal fa-cog icon-stack-1x opacity-100 color-white fa-spin"></i>
                        </span>
						Створити документ
					</h2>
					<div class="panel-toolbar">
						<button class="btn btn-panel waves-effect waves-themed" data-action="panel-fullscreen" data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen"></button>
					</div>
				</div>

				<div class="panel-container show">
					<div class="panel-content">
						<div class="memchik">
							<div class="row-container active_block_menu" v-if="current_step === 'menu_active'">
								<div class="row">
									<div class="col-md-1 col-xs-1 mobile-1">
										<menu_block key="menu_block_active"></menu_block>
									</div>

									<div class="col-md-11 col-xs-11 mobile-11">
										<mem_quest key="menu_quest_active"></mem_quest>
									</div>
								</div>
							</div>

							<div class="simple_block_menu" v-if="current_step === 'menu_show'">
								<menu_block key="menu_block_show"></menu_block>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="preview">
				<mem_preview key="mem_preview" v-if="current_step === 'mem_preview'"></mem_preview>
			</div>
		</div>
	</div>
</template>

<script>

import {createHelpers} from 'vuex-map-fields';
import menu_block from "./menu/menu_block.vue";
import mem_quest from "./quest/mem_quest.vue";
import mem_preview from "./mem_preview/mem_preview.vue";

const {mapFields} = createHelpers({
	getterType: 'memorandum_create/getMemCreateField',
	mutationType: 'memorandum_create/updateMemCreateField',
});


export default {
	name: "create_memorandum",
	components: {
		menu_block,
		mem_quest,
		mem_preview
	},
	data() {
		return {
			is_show : false,
		}
	},
	props: {
		addon_param: {
			type: String,
			required: false
		},
	},
    
    created() {
        if(this.addon_param != undefined) {
            IMC_CORE.showloading();
            this.load_active_addon(this.addon_param);
        }
    },
    
	methods: {
		async load_active_addon() {
            await api.get('/memorandum/menu/' + this.addon_param)
                .then(({data}) => {
                    IMC_CORE.hideloading();
                    if (data.status === "operation_success") {
                        this.$store.dispatch('memorandum_create/DELETE_ACTIVE_MENU');
                        this.$store.dispatch('memorandum_create/SET_ACTIVE_MENU',data.data);
                    } else {
                        EventBus.$emit('show_toast', {err: data.message, type: "danger", title: data.status})
                    }
                    
                }).catch(err => {
                    IMC_CORE.hideloading();
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
                });
		}
	},

	computed: {

		...mapFields([
			'current_step',
			'create_memorandum'
		]),

		current_class () {
			if(this.current_step === 'menu_active') {
				return 'small_view';
			}
			return 'normal';
		},


		show_create () {
			return this.current_step === 'menu_active' || this.current_step === 'menu_show';
		},

	},
}
</script>

<style scoped>

</style>
